function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  display: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  position: relative;\n  line-height: 16px;\n  cursor: ",
        ";\n  padding-top: 0;\n  margin-bottom: ",
        ";\n  ",
        "\n  .--bold {\n    font-weight: bold;\n    margin-right: 6px;\n  }\n\n  & > svg {\n    position: absolute;\n    left: 0;\n    top: 0;\n  }\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  height: 17px;\n  width: 17px;\n  opacity: 0;\n  position: absolute;\n  top: 0;\n  left: 0;\n  + span {\n    display: inline-block;\n  }\n  + span,\n  + .radioDiv {\n    color: #6d747b;\n    padding-left: 30px;\n    height: var(--radio-height);\n    width: 100%;\n    text-align: left;\n    padding-top: ",
        ";\n    padding-bottom: ",
        ";\n  }\n\n  &:disabled + span,\n  &:disabled + .radioDiv {\n    opacity: 0.5;\n    cursor: not-allowed;\n  }\n\n  &:checked:disabled + span,\n  &:checked:disabled + .radioDiv {\n    opacity: 0.5;\n    cursor: not-allowed;\n  }\n\n  &.focus-visible + span {\n    box-shadow: 0 0 0 2pt rgba(11, 153, 230, 0.4);\n  }\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  flex-direction: column;\n  margin-left: 35px;\n  gap: 12px;\n"
    ]);
    _templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState, useEffect, forwardRef } from 'react';
import { RadioGroup, Radio } from 'react-radio-group';
import _ from 'lodash';
import { display, fontSize as fontSizeStyled, width as widthStyled, margin as marginStyled, space } from 'styled-system';
import styled from 'styled-components';
import useStyledTheme from 'shared/hooks/use-styled-theme';
import { Label } from 'shared/components/legacy-rebass';
import RadioCheckedIcon from 'shared/assets/radio-checked';
import RadioUncheckedIcon from 'shared/assets/radio-unchecked';
import RadioDisabledIcon from 'shared/assets/radio-disabled';
import Tooltip from 'shared/components/tooltip';
var StyledRadioGroup = styled(RadioGroup)(_templateObject(), function(param) {
    var hasTooltips = param.hasTooltips;
    return hasTooltips ? 'flex' : 'block';
});
var RadioLabel = styled(Label)(_templateObject1(), display, fontSizeStyled, widthStyled, marginStyled, function(param) {
    var disabled = param.disabled;
    return disabled && 'not-allowed' || 'pointer';
}, function(param) {
    var marginBottom = param.marginBottom;
    return marginBottom || '4px';
}, space);
var StyledRadio = styled(Radio)(_templateObject2(), function(props) {
    return props.fontSize ? "calc((16px - ".concat(props.fontSize, ") / 2)") : '0';
}, function(props) {
    return props.fontSize ? "calc((16px - ".concat(props.fontSize, ") / 2)") : '0';
});
export default /*#__PURE__*/ forwardRef(function(/** @type { any } */ props, ref) {
    var handleChange = function handleChange(value) {
        setCurrentValue(value);
        onChange(value);
    };
    var checked = props.checked, _props_options = props.options, options = _props_options === void 0 ? [] : _props_options, _props_onChange = props.onChange, onChange = _props_onChange === void 0 ? _.noop : _props_onChange, _props_defaultValue = props.defaultValue, defaultValue = _props_defaultValue === void 0 ? '' : _props_defaultValue, _props_fontSize = props.fontSize, fontSize = _props_fontSize === void 0 ? '14px' : _props_fontSize, width = props.width, name = props.name, hasSublabels = props.hasSublabels, hasSubDescriptions = props.hasSubDescriptions, _props_required = props.required, required = _props_required === void 0 ? false : _props_required, _props_showChecksWhenDisabled = props.showChecksWhenDisabled, showChecksWhenDisabled = _props_showChecksWhenDisabled === void 0 ? false : _props_showChecksWhenDisabled, _props_updateCurrentValueWithDefaultValue = props.updateCurrentValueWithDefaultValue, updateCurrentValueWithDefaultValue = _props_updateCurrentValueWithDefaultValue === void 0 ? false : _props_updateCurrentValueWithDefaultValue, _props_hasTooltips = props.hasTooltips, hasTooltips = _props_hasTooltips === void 0 ? false : _props_hasTooltips, _props_tooltipOptions = props.tooltipOptions, tooltipOptions = _props_tooltipOptions === void 0 ? null : _props_tooltipOptions, otherProps = _object_without_properties(props, [
        "checked",
        "options",
        "onChange",
        "defaultValue",
        "fontSize",
        "width",
        "name",
        "hasSublabels",
        "hasSubDescriptions",
        "required",
        "showChecksWhenDisabled",
        "updateCurrentValueWithDefaultValue",
        "hasTooltips",
        "tooltipOptions"
    ]);
    var theme = useStyledTheme();
    // keep track of the current value
    var _useState = _sliced_to_array(useState(''), 2), currentValue = _useState[0], setCurrentValue = _useState[1];
    useEffect(function() {
        if (!_.isNil(checked)) {
            // set currentValue to checked prop if one is provided
            setCurrentValue(checked);
        } else if (currentValue === '' && defaultValue !== '' && !_.isNil(defaultValue)) {
            // if we don't start with a default value but then get one, we should default to that
            setCurrentValue(defaultValue);
        } else if (updateCurrentValueWithDefaultValue && currentValue !== defaultValue) {
            // if updateCurrentValueWithDefaultValue is true, then defaultValue is allowed to change and currentValue should
            // reflect it
            setCurrentValue(defaultValue);
        }
    }, [
        checked,
        currentValue,
        defaultValue
    ]);
    return /*#__PURE__*/ _jsx(StyledRadioGroup, {
        name: name,
        ref: ref,
        onChange: handleChange,
        selectedValue: currentValue,
        role: "radiogroup",
        "aria-label": name,
        hasTooltips: hasTooltips,
        children: _.map(options, function(option) {
            var _theme_customized_colors, _theme_customized, _theme_colors;
            var label = option.label, sublabel = option.sublabel, subDescription = option.subDescription, value = option.value, disabled = option.disabled, LabelComponent = option.LabelComponent, _option_marginRight = option.marginRight, marginRight = _option_marginRight === void 0 ? '45px' : _option_marginRight, marginBottom = option.marginBottom;
            var tooltipCopy = tooltipOptions === null || tooltipOptions === void 0 ? void 0 : tooltipOptions[value];
            var _theme_customized_colors_buttonsLinks;
            return /*#__PURE__*/ _jsxs(RadioLabel, _object_spread_props(_object_spread({
                mr: marginRight,
                fontSize: fontSize,
                width: option.width || width,
                mb: marginBottom
            }, otherProps), {
                children: [
                    /*#__PURE__*/ _jsx(StyledRadio, {
                        name: "radio",
                        value: value,
                        disabled: disabled,
                        fontSize: fontSize,
                        "data-cy": option.radioButtonDataCyName,
                        "data-test": option.radioButtonDataCyName,
                        "data-testid": option.radioButtonDataCyName,
                        "aria-checked": value === currentValue,
                        role: "radio",
                        required: required
                    }),
                    hasSublabels && !hasSubDescriptions && !LabelComponent && /*#__PURE__*/ _jsxs("span", {
                        children: [
                            /*#__PURE__*/ _jsx("span", {
                                className: "--bold",
                                "data-cy": option.dataCyName || '',
                                "data-test": option.dataCyName || '',
                                "data-testid": option.dataCyName || '',
                                children: label
                            }),
                            /*#__PURE__*/ _jsx("span", {
                                children: sublabel
                            })
                        ]
                    }),
                    hasSublabels && hasSubDescriptions && !LabelComponent && /*#__PURE__*/ _jsxs(StyledSubDescriptionWrapper, {
                        children: [
                            /*#__PURE__*/ _jsxs("div", {
                                children: [
                                    /*#__PURE__*/ _jsx("span", {
                                        className: "--bold",
                                        "data-cy": option.dataCyName || '',
                                        "data-test": option.dataCyName || '',
                                        "data-testid": option.dataCyName || '',
                                        children: label
                                    }),
                                    /*#__PURE__*/ _jsx("span", {
                                        children: sublabel
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx("p", {
                                children: subDescription
                            })
                        ]
                    }),
                    !hasSublabels && !LabelComponent && /*#__PURE__*/ _jsx("span", {
                        children: label
                    }),
                    LabelComponent && /*#__PURE__*/ _jsx("div", {
                        className: "radioDiv",
                        children: /*#__PURE__*/ _jsx(LabelComponent, {})
                    }),
                    (!disabled || showChecksWhenDisabled) && value === currentValue && /*#__PURE__*/ _jsx(RadioCheckedIcon, {
                        color: disabled ? '#b7bec3' : (_theme_customized_colors_buttonsLinks = theme === null || theme === void 0 ? void 0 : (_theme_customized = theme.customized) === null || _theme_customized === void 0 ? void 0 : (_theme_customized_colors = _theme_customized.colors) === null || _theme_customized_colors === void 0 ? void 0 : _theme_customized_colors.buttonsLinks) !== null && _theme_customized_colors_buttonsLinks !== void 0 ? _theme_customized_colors_buttonsLinks : theme === null || theme === void 0 ? void 0 : (_theme_colors = theme.colors) === null || _theme_colors === void 0 ? void 0 : _theme_colors.primaryBlue
                    }),
                    !disabled && value !== currentValue && /*#__PURE__*/ _jsx(RadioUncheckedIcon, {}),
                    disabled && value !== currentValue && /*#__PURE__*/ _jsx(RadioDisabledIcon, {
                        cursor: "not-allowed"
                    }),
                    hasTooltips && tooltipCopy && /*#__PURE__*/ _jsx(Tooltip, {
                        tooltipCopy: tooltipCopy,
                        grey: true,
                        left: "auto",
                        bottom: "30px",
                        right: "-61px",
                        width: "239px"
                    })
                ]
            }), value);
        })
    });
});
var StyledSubDescriptionWrapper = styled.div(_templateObject3());
